export function getPrimeVueLocale(lang) {
    const locales = {
        pt: {
            startsWith: "Começa com",
            contains: "Contém",
            notContains: "Não contém",
            endsWith: "Termina com",
            equals: "Igual",
            notEquals: "Diferente",
            noFilter: "Sem filtro",
            filter: "Filtro",
            lt: "Menor que",
            lte: "Menor que ou igual a",
            gt: "Maior que",
            gte: "Maior que ou igual a",
            dateIs: "Data é",
            dateIsNot: "Data não é",
            dateBefore: "Data é anterior",
            dateAfter: "Data é posterior",
            custom: "Customizado",
            clear: "Limpar",
            close: "Fechar",
            apply: "Aplicar",
            matchAll: "Combine tudo",
            matchAny: "Combine qualquer",
            addRule: "Adicionar Regra",
            removeRule: "Remover Regra",
            accept: "Sim",
            reject: "Não",
            choose: "Escolha",
            upload: "Upload",
            cancel: "Cancelar",
            completed: "Concluído",
            pending: "Pendente",
            fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
            dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
            monthNames: [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
            ],
            monthNamesShort: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez"
            ],
            chooseYear: "Escolha Ano",
            chooseMonth: "Escolha Mês",
            chooseDate: "Escolha Data",
            prevDecade: "Década Anterior",
            nextDecade: "Década Seguinte",
            prevYear: "Ano Anterior",
            nextYear: "Ano Seguinte",
            prevMonth: "Mês Anterior",
            nextMonth: "Mês Seguinte",
            prevHour: "Hora Anterior",
            nextHour: "Hora Seguinte",
            prevMinute: "Minuto Anterior",
            nextMinute: "Minuto Seguinte",
            prevSecond: "Segundo Anterior",
            nextSecond: "Segundo Seguinte",
            am: "AM",
            pm: "PM",
            today: "Hoje",
            now: "Agora",
            weekHeader: "Sem",
            firstDayOfWeek: 0,
            showMonthAfterYear: false,
            dateFormat: "dd/mm/yy",
            weak: "Fraco",
            medium: "Médio",
            strong: "Forte",
            passwordPrompt: "Digite uma senha",
            emptyFilterMessage: "Nenhum resultado encontrado",
            searchMessage: "{0} resultados disponíveis",
            selectionMessage: "{0} itens selecionados",
            emptySelectionMessage: "Nenhum item selecionado",
            emptySearchMessage: "Nenhum resultado encontrado",
            emptyMessage: "Nenhuma opção disponível",
            aria: {
                trueLabel: "Verdadeiro",
                falseLabel: "Falso",
                nullLabel: "Não selecionado",
                star: "1 estrela",
                stars: "{star} estrelas",
                selectAll: "Todos itens selecionados",
                unselectAll: "Nenhum item selecionado",
                close: "Fechar",
                previous: "Anterior",
                next: "Seguinte",
                navigation: "Navegação",
                scrollTop: "Rolar para Topo",
                moveTop: "Mover para Topo",
                moveUp: "Mover para Cima",
                moveDown: "Mover para Baixo",
                moveBottom: "Mover para Final",
                moveToTarget: "Mover para Alvo",
                moveToSource: "Mover para Fonte",
                moveAllToTarget: "Mover Todos para Alvo",
                moveAllToSource: "Mover Todos para Fonte",
                pageLabel: "Página {page}",
                firstPageLabel: "Primeira Página",
                lastPageLabel: "Última Página",
                nextPageLabel: "Página Seguinte",
                previousPageLabel: "Página Anterior",
                rowsPerPageLabel: "Linhas por página",
                jumpToPageDropdownLabel: "Pular para Menu da Página",
                jumpToPageInputLabel: "Pular para Campo da Página",
                selectRow: "Linha Selecionada",
                unselectRow: "Linha Não Selecionada",
                expandRow: "Linha Expandida",
                collapseRow: "Linha Recolhida",
                showFilterMenu: "Mostrar Menu de Filtro",
                hideFilterMenu: "Esconder Menu de Filtro",
                filterOperator: "Operador de Filtro",
                filterConstraint: "Restrição de Filtro",
                editRow: "Editar Linha",
                saveEdit: "Salvar Edição",
                cancelEdit: "Cancelar Edição",
                listView: "Exibição em Lista",
                gridView: "Exibição em Grade",
                slide: "Deslizar",
                slideNumber: "{slideNumber}",
                zoomImage: "Ampliar Imagem",
                zoomIn: "Mais Zoom",
                zoomOut: "Menos Zoom",
                rotateRight: "Girar à Direita",
                rotateLeft: "Girar à Esquerda"
            }
        },
        en: {
            startsWith: "Starts with",
            contains: "Contains",
            notContains: "Does not contain",
            endsWith: "Ends with",
            equals: "Equals",
            notEquals: "Not equals",
            noFilter: "No filter",
            filter: "Filter",
            lt: "Less than",
            lte: "Less than or equal to",
            gt: "Greater than",
            gte: "Greater than or equal to",
            dateIs: "Date is",
            dateIsNot: "Date is not",
            dateBefore: "Date is before",
            dateAfter: "Date is after",
            custom: "Custom",
            clear: "Clear",
            close: "Close",
            apply: "Apply",
            matchAll: "Match all",
            matchAny: "Match any",
            addRule: "Add Rule",
            removeRule: "Remove Rule",
            accept: "Yes",
            reject: "No",
            choose: "Choose",
            upload: "Upload",
            cancel: "Cancel",
            completed: "Completed",
            pending: "Pending",
            fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthNamesShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            chooseYear: "Choose Year",
            chooseMonth: "Choose Month",
            chooseDate: "Choose Date",
            prevDecade: "Previous Decade",
            nextDecade: "Next Decade",
            prevYear: "Previous Year",
            nextYear: "Next Year",
            prevMonth: "Previous Month",
            nextMonth: "Next Month",
            prevHour: "Previous Hour",
            nextHour: "Next Hour",
            prevMinute: "Previous Minute",
            nextMinute: "Next Minute",
            prevSecond: "Previous Second",
            nextSecond: "Next Second",
            am: "AM",
            pm: "PM",
            today: "Today",
            now: "Now",
            weekHeader: "Wk",
            firstDayOfWeek: 0,
            showMonthAfterYear: false,
            dateFormat: "mm/dd/yy",
            weak: "Weak",
            medium: "Medium",
            strong: "Strong",
            passwordPrompt: "Enter a password",
            emptyFilterMessage: "No results found",
            searchMessage: "{0} results are available",
            selectionMessage: "{0} items selected",
            emptySelectionMessage: "No items selected",
            emptySearchMessage: "No results found",
            emptyMessage: "No available options",
            aria: {
                trueLabel: "True",
                falseLabel: "False",
                nullLabel: "Not selected",
                star: "1 star",
                stars: "{star} stars",
                selectAll: "All items selected",
                unselectAll: "All items unselected",
                close: "Close",
                previous: "Previous",
                next: "Next",
                navigation: "Navigation",
                scrollTop: "Scroll to Top",
                moveTop: "Move to Top",
                moveUp: "Move Up",
                moveDown: "Move Down",
                moveBottom: "Move to Bottom",
                moveToTarget: "Move to Target",
                moveToSource: "Move to Source",
                moveAllToTarget: "Move All to Target",
                moveAllToSource: "Move All to Source",
                pageLabel: "Page {page}",
                firstPageLabel: "First Page",
                lastPageLabel: "Last Page",
                nextPageLabel: "Next Page",
                previousPageLabel: "Previous Page",
                rowsPerPageLabel: "Rows per page",
                jumpToPageDropdownLabel: "Jump to Page Dropdown",
                jumpToPageInputLabel: "Jump to Page Input",
                selectRow: "Row Selected",
                unselectRow: "Row Unselected",
                expandRow: "Row Expanded",
                collapseRow: "Row Collapsed",
                showFilterMenu: "Show Filter Menu",
                hideFilterMenu: "Hide Filter Menu",
                filterOperator: "Filter Operator",
                filterConstraint: "Filter Constraint",
                editRow: "Edit Row",
                saveEdit: "Save Edit",
                cancelEdit: "Cancel Edit",
                listView: "List View",
                gridView: "Grid View",
                slide: "Slide",
                slideNumber: "{slideNumber}",
                zoomImage: "Zoom Image",
                zoomIn: "Zoom In",
                zoomOut: "Zoom Out",
                rotateRight: "Rotate Right",
                rotateLeft: "Rotate Left"
            }
        },
        es: {
            startsWith: "Comienza con",
            contains: "Contiene",
            notContains: "No contiene",
            endsWith: "Termina con",
            equals: "Igual",
            notEquals: "No igual",
            noFilter: "Sin filtro",
            filter: "Filtro",
            lt: "Menor que",
            lte: "Menor o igual a",
            gt: "Mayor que",
            gte: "Mayor o igual a",
            dateIs: "La fecha es",
            dateIsNot: "La fecha no es",
            dateBefore: "La fecha es anterior",
            dateAfter: "La fecha es posterior",
            custom: "Personalizado",
            clear: "Limpiar",
            close: "Cerrar",
            apply: "Aplicar",
            matchAll: "Coincidir todo",
            matchAny: "Coincidir cualquiera",
            addRule: "Agregar Regla",
            removeRule: "Eliminar Regla",
            accept: "Sí",
            reject: "No",
            choose: "Elegir",
            upload: "Subir",
            cancel: "Cancelar",
            completed: "Completado",
            pending: "Pendiente",
            fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            monthNamesShort: [
                "Ene",
                "Feb",
                "Mar",
                "Abr",
                "May",
                "Jun",
                "Jul",
                "Ago",
                "Sep",
                "Oct",
                "Nov",
                "Dic"
            ],
            chooseYear: "Elegir Año",
            chooseMonth: "Elegir Mes",
            chooseDate: "Elegir Fecha",
            prevDecade: "Década Anterior",
            nextDecade: "Década Siguiente",
            prevYear: "Año Anterior",
            nextYear: "Año Siguiente",
            prevMonth: "Mes Anterior",
            nextMonth: "Mes Siguiente",
            prevHour: "Hora Anterior",
            nextHour: "Hora Siguiente",
            prevMinute: "Minuto Anterior",
            nextMinute: "Minuto Siguiente",
            prevSecond: "Segundo Anterior",
            nextSecond: "Segundo Siguiente",
            am: "AM",
            pm: "PM",
            today: "Hoy",
            now: "Ahora",
            weekHeader: "Sem",
            firstDayOfWeek: 0,
            showMonthAfterYear: false,
            dateFormat: "dd/mm/yy",
            weak: "Débil",
            medium: "Medio",
            strong: "Fuerte",
            passwordPrompt: "Ingrese una contraseña",
            emptyFilterMessage: "No se encontraron resultados",
            searchMessage: "{0} resultados disponibles",
            selectionMessage: "{0} elementos seleccionados",
            emptySelectionMessage: "Ningún elemento seleccionado",
            emptySearchMessage: "No se encontraron resultados",
            emptyMessage: "No hay opciones disponibles",
            aria: {
                trueLabel: "Verdadero",
                falseLabel: "Falso",
                nullLabel: "No seleccionado",
                star: "1 estrella",
                stars: "{star} estrellas",
                selectAll: "Todos los elementos seleccionados",
                unselectAll: "Ningún elemento seleccionado",
                close: "Cerrar",
                previous: "Anterior",
                next: "Siguiente",
                navigation: "Navegación",
                scrollTop: "Desplazarse Arriba",
                moveTop: "Mover Arriba",
                moveUp: "Subir",
                moveDown: "Bajar",
                moveBottom: "Mover Abajo",
                moveToTarget: "Mover al Destino",
                moveToSource: "Mover al Origen",
                moveAllToTarget: "Mover Todo al Destino",
                moveAllToSource: "Mover Todo al Origen",
                pageLabel: "Página {page}",
                firstPageLabel: "Primera Página",
                lastPageLabel: "Última Página",
                nextPageLabel: "Página Siguiente",
                previousPageLabel: "Página Anterior",
                rowsPerPageLabel: "Filas por página",
                jumpToPageDropdownLabel: "Ir al menú de página",
                jumpToPageInputLabel: "Ir al campo de página",
                selectRow: "Fila Seleccionada",
                unselectRow: "Fila No Seleccionada",
                expandRow: "Fila Expandida",
                collapseRow: "Fila Colapsada",
                showFilterMenu: "Mostrar Menú de Filtro",
                hideFilterMenu: "Ocultar Menú de Filtro",
                filterOperator: "Operador de Filtro",
                filterConstraint: "Restricción de Filtro",
                editRow: "Editar Fila",
                saveEdit: "Guardar Edición",
                cancelEdit: "Cancelar Edición",
                listView: "Vista de Lista",
                gridView: "Vista de Cuadrícula",
                slide: "Diapositiva",
                slideNumber: "{slideNumber}",
                zoomImage: "Ampliar Imagen",
                zoomIn: "Acercar",
                zoomOut: "Alejar",
                rotateRight: "Girar a la Derecha",
                rotateLeft: "Girar a la Izquierda"
            }
        }
    };
    return locales[lang] || locales.pt;
}
